import Loadable from 'components/global/Loadable';
import SimpleCard from 'components/global/SimpleCard';
import CompanySnapshotRow from 'components/global/CompanySnapShotRow';
import { $detail, $view } from 'signals/global.signals';
import { formatMoneyShorthand } from 'utils/formatMoney';

const FounderDealDetail = () => (
  <SimpleCard>
    <Loadable signal={$view}>
      <CompanySnapshotRow label="Type of Raise" value={$detail.value?.typeOfRaise} />
      <CompanySnapshotRow label="Investment Stage" value={$detail.value?.investmentStage} />
      <CompanySnapshotRow label="Current Raise Size" value={formatMoneyShorthand($detail.value?.currentRaiseSize)} />
      <CompanySnapshotRow label="Amount Committed" value={formatMoneyShorthand($detail.value?.amountCommitted)} />
      <CompanySnapshotRow label="Amount Previously Raised" value={formatMoneyShorthand($detail.value?.amountPreviouslyRaised)} />
      <CompanySnapshotRow label="Minimum Investment" value={$detail.value?.minimumInvestment ? formatMoneyShorthand($detail.value?.minimumInvestment) : 'Not specified'} />
      <CompanySnapshotRow label="Pre-Money Valuation" value={$detail.value?.preMoneyValuation ? formatMoneyShorthand($detail.value?.preMoneyValuation) : 'Not specified'} />
    </Loadable>
  </SimpleCard>
);

export default FounderDealDetail;
